export function mainNav(header) {
    var mTrigger = header.querySelector('.autonet-mobile-trigger');
    var mNav = header.querySelector('.autonet-mobile-nav');
    var cls = {
        opened: 'opened',
        locked: 'locked',
        iconBars: 'fa-bars',
        iconClose: 'fa-times'
    };
    var opened = false;
    if (mTrigger && mNav) {
        var mTriggerIcon_1 = mTrigger.querySelector('.fa-regular');
        mTrigger.addEventListener('click', function () {
            if (!opened) {
                mNav.classList.add(cls.opened);
                document.body.classList.add(cls.locked);
                if (mTriggerIcon_1) {
                    mTriggerIcon_1.classList.remove(cls.iconBars);
                    mTriggerIcon_1.classList.add(cls.iconClose);
                }
                opened = true;
                return;
            }
            mNav.classList.remove(cls.opened);
            document.body.classList.remove(cls.locked);
            if (mTriggerIcon_1) {
                mTriggerIcon_1.classList.remove(cls.iconClose);
                mTriggerIcon_1.classList.add(cls.iconBars);
            }
            opened = false;
        });
    }
}
